var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItbImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 80,
    width: 400,
    height: 280,
    fill: "#4285F4",
    stroke: "#1a73e8",
    strokeWidth: 20,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 80 L250 240 L450 80",
    fill: "none",
    stroke: "#1a73e8",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 180,
    x2: 400,
    y2: 180,
    stroke: "#ffffff",
    strokeWidth: 14,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 240,
    x2: 380,
    y2: 240,
    stroke: "#ffffff",
    strokeWidth: 14,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "import-icon",
    transform: "translate(380, 180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 60,
    fill: "#ffffff",
    stroke: "#1a73e8",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -30 L0 20 M-15 8 L0 20 L15 8",
    stroke: "#1a73e8",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 25,
    width: 50,
    height: 30,
    fill: "#1a73e8",
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -20,
    y1: 35,
    x2: 20,
    y2: 35,
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -20,
    y1: 45,
    x2: 20,
    y2: 45,
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItbImport);
export default __webpack_public_path__ + "static/media/itb-import.d35db5db5486665e2bbe9d9cb621e571.svg";
export { ForwardRef as ReactComponent };